// MDX v2 (Wolfenstein skeletal animation): the bone hierarchy and, per frame,
// the root position plus compressed bone angles. Layout: qfiles.h.

import { BinReader } from './bin';

export interface MdxBoneInfo {
  name: string;
  parent: number;
  /** Share of the torso rotation (about the torsoParent bone) this bone gets. */
  torsoWeight: number;
  parentDist: number;
  flags: number;
}

export interface MdxModel {
  name: string;
  numFrames: number;
  numBones: number;
  torsoParent: number;
  bones: MdxBoneInfo[];
  /** Per frame: parentOffset (3 floats). */
  parentOffsets: Float32Array;
  /** Per frame and bone: angles[3], (angles[3] unused), ofsAngles[2] as shorts: 6 per bone. */
  boneFrames: Int16Array;
}

/** Frame header: bounds[2], localOrigin, radius, parentOffset. */
const FRAME_HEADER = 52;
const BONE_FRAME = 12;

export function parseMdx(data: Uint8Array, name = 'mdx'): MdxModel {
  const r = new BinReader(data);
  r.check('MDXW', [2], name);
  const numFrames = r.i32(72);
  const numBones = r.i32(76);
  const ofsFrames = r.i32(80);
  const ofsBones = r.i32(84);
  const torsoParent = r.i32(88);

  const bones: MdxBoneInfo[] = [];
  for (let i = 0; i < numBones; i++) {
    const o = ofsBones + i * 80;
    bones.push({ name: r.str(o), parent: r.i32(o + 64), torsoWeight: r.f32(o + 68), parentDist: r.f32(o + 72), flags: r.i32(o + 76) });
  }

  const parentOffsets = new Float32Array(numFrames * 3);
  const boneFrames = new Int16Array(numFrames * numBones * 6);
  const frameSize = FRAME_HEADER + numBones * BONE_FRAME;
  for (let f = 0; f < numFrames; f++) {
    const o = ofsFrames + f * frameSize;
    parentOffsets[f * 3] = r.f32(o + 40);
    parentOffsets[f * 3 + 1] = r.f32(o + 44);
    parentOffsets[f * 3 + 2] = r.f32(o + 48);
    const base = f * numBones * 6;
    for (let k = 0; k < numBones * 6; k++) boneFrames[base + k] = r.i16(o + FRAME_HEADER + k * 2);
  }
  return { name: r.str(8), numFrames, numBones, torsoParent, bones, parentOffsets, boneFrames };
}
